import React from 'react';
import { useSelector } from 'react-redux';

// Components
import Init from 'components/_utility/Init/Init';
import DummyHeader from 'components/_utility/DummyHeader/DummyHeader';
import StepSwitch from 'components/StepSwitch';
import { Wrap } from './App.styled';
import ErrorBoundary from './ErrorBoundary';
import { getErrorSelector } from './redux/app/selectors';

const App = ({ contentApiEndpoint, basepath }) => {
  const error = useSelector(getErrorSelector);

  return (
    <Wrap>
      <ErrorBoundary error={error}>
        <Init contentApiEndpoint={contentApiEndpoint} basepath={basepath}>
          {process.env.NODE_ENV === 'development' ? <DummyHeader /> : null}
          <StepSwitch></StepSwitch>
        </Init>
      </ErrorBoundary>
    </Wrap>
  );
};

export default App;
